import React, { useState } from "react";
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import logo from '../assets/mss.png';
import SignIn from "../auth/Signin";
import {
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
}
from 'mdb-react-ui-kit';
import SignUp from "../auth/Signup";
import { Link } from "react-router-dom";
export function StickyNavbar() {
  // const [openNav, setOpenNav] = React.useState(false);
 
  // React.useEffect(() => {
  //   window.addEventListener(
  //     "resize",
  //     () => window.innerWidth >= 960 && setOpenNav(false),
  //   );
  // }, []);
 

 const [startsignin,setstartsignin]=useState(false)
 const [basicModal, setBasicModal] = useState(false);

 const toggleOpen = () => {
  setBasicModal(!basicModal)
};
  return (
    <div>
    <Navbar  collapseOnSelect expand="lg" sticky="top" className="bg-body-tertiary dark">
      <Container>
       <img className="imgbg" alt="logo" src={logo} width="60" height="70"/>
        <Navbar.Brand href="/">Modern Software Solutions</Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link ><Link style={{textDecoration:"none",color:"black"}} to="/features">Features</Link></Nav.Link>
            <Nav.Link ><Link style={{textDecoration:"none",color:"black"}} to="/pricing">Pricing</Link></Nav.Link>
            {/* <NavDropdown title="Dropdown" id="collapsible-nav-dropdown">
              <NavDropdown.Item href="#action/3.1">Action</NavDropdown.Item>
              <NavDropdown.Item href="#action/3.2">
                Another action
              </NavDropdown.Item>
              <NavDropdown.Item href="#action/3.3">Something</NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item href="#action/3.4">
                Separated link
              </NavDropdown.Item>
            </NavDropdown> */}
          </Nav>
          <Nav>
            {/* <Nav.Link onClick={()=>{
              toggleOpen();
              setstartsignin(true)
            }}>Sing-In</Nav.Link> */}
            <Nav.Link style={{backgroundColor:"blanchedalmond",border:0,borderRadius:"10px",padding:"10px"}} eventKey={2} onClick={()=>{
              toggleOpen()
              setstartsignin(false)
            }}>
            Contact-Us
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
   
       
        
      
    </Navbar>
    <MDBModal  open={basicModal} setOpen={setBasicModal} tabIndex='0'>
        <MDBModalDialog centered  size="lg">
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle style={{justifyContent:"center"}}>Modern Software Solutions</MDBModalTitle>
              <MDBBtn className='btn-close' color='none' onClick={()=>{
                toggleOpen();
                setstartsignin(!startsignin)
              }}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              {
                startsignin?<SignIn />:<SignUp />
              }
            
        </MDBModalBody>
        </MDBModalContent>
        </MDBModalDialog>
        </MDBModal>
        </div>

  );
}